(() => {
  'use strict';
  const dialog = document.querySelector('[data-search-overlay]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const input = dialog.querySelector('[data-search-input]');
  const defaults = dialog.querySelector('[data-search-default]');
  const results = dialog.querySelector('[data-search-results]');
  const status = dialog.querySelector('[data-search-status]');
  const all = dialog.querySelector('[data-search-all]');
  const form = dialog.querySelector('form');
  if (!input || !defaults || !results || !status || !all || !form) return;
  let trigger, controller, timer, generation = 0;
  const cancel = () => {
    generation++;
    clearTimeout(timer);
    controller?.abort();
    dialog.removeAttribute('aria-busy');
  };
  const reset = () => {
    cancel();
    defaults.hidden = false;
    results.hidden = true;
    results.replaceChildren();
    all.hidden = true;
    status.textContent = '';
  };
  const search = async () => {
    const query = input.value.trim();
    if (!dialog.open || query.length < 2) { reset(); return; }
    const request = ++generation;
    controller?.abort();
    controller = new AbortController();
    dialog.setAttribute('aria-busy','true');
    status.textContent = dialog.dataset.loading;
    try {
      const url = new URL(dialog.dataset.searchUrl,location.origin);
      url.searchParams.set('q',query);
      url.searchParams.set('section_id','lh-search-overlay-results');
      url.searchParams.set('type','product');
      url.searchParams.set('options[prefix]','last');
      const response = await fetch(url,{signal:controller.signal,credentials:'same-origin'});
      if (!response.ok) throw new Error('Search unavailable');
      const documentResult = new DOMParser().parseFromString(await response.text(),'text/html');
      if (request !== generation || !dialog.open || input.value.trim() !== query) return;
      const content = documentResult.querySelector('[data-search-overlay-content]');
      if (!content) throw new Error('Search response unavailable');
      if ((content.dataset.searchQuery || '').trim().toLocaleLowerCase() !== query.toLocaleLowerCase()) throw new Error('Search response does not match the requested query');
      results.replaceChildren(document.importNode(content,true));
      results.hidden = false;
      const empty = content.querySelector('[data-search-empty]');
      status.textContent = empty ? empty.textContent : dialog.dataset.ready;
    } catch (error) {
      if (error.name !== 'AbortError' && request === generation && dialog.open) status.textContent = dialog.dataset.error;
    } finally {
      if (request === generation) dialog.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click',event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-search-open]');
    if (!link) return;
    event.preventDefault();
    if (dialog.open) return;
    trigger = link;
    document.querySelectorAll('.lh-nav-disclosure[open]').forEach(item => { item.open = false; });
    input.value = '';
    reset();
    dialog.showModal();
    document.documentElement.setAttribute('data-lh-search-open','');
    input.focus({preventScroll:true});
  });
  dialog.querySelector('[data-search-close]')?.addEventListener('click',() => dialog.close());
  dialog.addEventListener('keydown',event => { if (event.key === 'Escape') { event.preventDefault(); dialog.close(); } });
  dialog.addEventListener('close',() => {
    cancel();
    document.documentElement.removeAttribute('data-lh-search-open');
    if (trigger?.isConnected) trigger.focus({preventScroll:true});
  });
  input.addEventListener('input',event => {
    if (event.isComposing) return;
    cancel();
    if (input.value.trim().length < 2) { reset(); return; }
    defaults.hidden = true;
    results.hidden = true;
    all.hidden = false;
    status.textContent = dialog.dataset.loading;
    timer = setTimeout(search,200);
  });
  input.addEventListener('compositionend',() => input.dispatchEvent(new Event('input',{bubbles:true})));
  form.addEventListener('submit',cancel);
})();
